import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["static"],
  _excluded2 = ["unmount"],
  _excluded3 = ["as", "children", "refName"];
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Fragment as R, cloneElement as P, createElement as E, forwardRef as j, isValidElement as v, useCallback as S, useRef as w } from "react";
import { classNames as x } from './class-names.js';
import { match as k } from './match.js';
var M = function (a) {
    return a[a.None = 0] = "None", a[a.RenderStrategy = 1] = "RenderStrategy", a[a.Static = 2] = "Static", a;
  }(M || {}),
  O = function (e) {
    return e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e;
  }(O || {});
function H(_ref) {
  var r = _ref.ourProps,
    n = _ref.theirProps,
    e = _ref.slot,
    a = _ref.defaultTag,
    s = _ref.features,
    _ref$visible = _ref.visible,
    t = _ref$visible === void 0 ? !0 : _ref$visible,
    l = _ref.name,
    i = _ref.mergeRefs;
  i = i != null ? i : A;
  var o = N(n, r);
  if (t) return b(o, e, a, l, i);
  var y = s != null ? s : 0;
  if (y & 2) {
    var _o$static = o.static,
      f = _o$static === void 0 ? !1 : _o$static,
      u = _objectWithoutProperties(o, _excluded);
    if (f) return b(u, e, a, l, i);
  }
  if (y & 1) {
    var _o$unmount = o.unmount,
      _f = _o$unmount === void 0 ? !0 : _o$unmount,
      _u = _objectWithoutProperties(o, _excluded2);
    return k(_f ? 0 : 1, _defineProperty(_defineProperty({}, 0, function _() {
      return null;
    }), 1, function _() {
      return b(_objectSpread(_objectSpread({}, _u), {}, {
        hidden: !0,
        style: {
          display: "none"
        }
      }), e, a, l, i);
    }));
  }
  return b(o, e, a, l, i);
}
function b(r) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var e = arguments.length > 2 ? arguments[2] : undefined;
  var a = arguments.length > 3 ? arguments[3] : undefined;
  var s = arguments.length > 4 ? arguments[4] : undefined;
  var _h = h(r, ["unmount", "static"]),
    _h$as = _h.as,
    t = _h$as === void 0 ? e : _h$as,
    l = _h.children,
    _h$refName = _h.refName,
    i = _h$refName === void 0 ? "ref" : _h$refName,
    o = _objectWithoutProperties(_h, _excluded3),
    y = r.ref !== void 0 ? _defineProperty({}, i, r.ref) : {},
    f = typeof l == "function" ? l(n) : l;
  "className" in o && o.className && typeof o.className == "function" && (o.className = o.className(n)), o["aria-labelledby"] && o["aria-labelledby"] === o.id && (o["aria-labelledby"] = void 0);
  var u = {};
  if (n) {
    var d = !1,
      p = [];
    for (var _i = 0, _Object$entries = Object.entries(n); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        c = _Object$entries$_i[0],
        T = _Object$entries$_i[1];
      typeof T == "boolean" && (d = !0), T === !0 && p.push(c.replace(/([A-Z])/g, function (g) {
        return "-".concat(g.toLowerCase());
      }));
    }
    if (d) {
      u["data-headlessui-state"] = p.join(" ");
      var _iterator = _createForOfIteratorHelper(p),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _c = _step.value;
          u["data-".concat(_c)] = "";
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }
  if (t === R && (Object.keys(m(o)).length > 0 || Object.keys(m(u)).length > 0)) if (!v(f) || Array.isArray(f) && f.length > 1) {
    if (Object.keys(m(o)).length > 0) throw new Error(['Passing props on "Fragment"!', "", "The current component <".concat(a, " /> is rendering a \"Fragment\"."), "However we need to passthrough the following props:", Object.keys(m(o)).concat(Object.keys(m(u))).map(function (d) {
      return "  - ".concat(d);
    }).join("\n"), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map(function (d) {
      return "  - ".concat(d);
    }).join("\n")].join("\n"));
  } else {
    var _d = f.props,
      _p = _d == null ? void 0 : _d.className,
      _c2 = typeof _p == "function" ? function () {
        return x(_p.apply(void 0, arguments), o.className);
      } : x(_p, o.className),
      _T = _c2 ? {
        className: _c2
      } : {},
      g = N(f.props, m(h(o, ["ref"])));
    for (var F in u) F in g && delete u[F];
    return P(f, Object.assign({}, g, u, y, {
      ref: s(f.ref, y.ref)
    }, _T));
  }
  return E(t, Object.assign({}, h(o, ["ref"]), t !== R && y, t !== R && u), f);
}
function I() {
  var r = w([]),
    n = S(function (e) {
      var _iterator2 = _createForOfIteratorHelper(r.current),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var a = _step2.value;
          a != null && (typeof a == "function" ? a(e) : a.current = e);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }, []);
  return function () {
    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }
    if (!e.every(function (a) {
      return a == null;
    })) return r.current = e, n;
  };
}
function A() {
  for (var _len2 = arguments.length, r = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    r[_key2] = arguments[_key2];
  }
  return r.every(function (n) {
    return n == null;
  }) ? void 0 : function (n) {
    var _iterator3 = _createForOfIteratorHelper(r),
      _step3;
    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var e = _step3.value;
        e != null && (typeof e == "function" ? e(n) : e.current = n);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  };
}
function N() {
  var a;
  for (var _len3 = arguments.length, r = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    r[_key3] = arguments[_key3];
  }
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  var n = {},
    e = {};
  for (var _i2 = 0, _r = r; _i2 < _r.length; _i2++) {
    var s = _r[_i2];
    for (var t in s) t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : n[t] = s[t];
  }
  if (n.disabled || n["aria-disabled"]) for (var _s in e) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(_s) && (e[_s] = [function (t) {
    var l;
    return (l = t == null ? void 0 : t.preventDefault) == null ? void 0 : l.call(t);
  }]);
  var _loop = function _loop(_s2) {
    Object.assign(n, _defineProperty({}, _s2, function (t) {
      var i = e[_s2];
      for (var _len4 = arguments.length, l = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        l[_key4 - 1] = arguments[_key4];
      }
      var _iterator4 = _createForOfIteratorHelper(i),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var o = _step4.value;
          if ((t instanceof Event || (t == null ? void 0 : t.nativeEvent) instanceof Event) && t.defaultPrevented) return;
          o.apply(void 0, [t].concat(l));
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
    }));
  };
  for (var _s2 in e) {
    _loop(_s2);
  }
  return n;
}
function D() {
  var a;
  for (var _len5 = arguments.length, r = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
    r[_key5] = arguments[_key5];
  }
  if (r.length === 0) return {};
  if (r.length === 1) return r[0];
  var n = {},
    e = {};
  for (var _i3 = 0, _r2 = r; _i3 < _r2.length; _i3++) {
    var s = _r2[_i3];
    for (var t in s) t.startsWith("on") && typeof s[t] == "function" ? ((a = e[t]) != null || (e[t] = []), e[t].push(s[t])) : n[t] = s[t];
  }
  var _loop2 = function _loop2(_s3) {
    Object.assign(n, _defineProperty({}, _s3, function () {
      var l = e[_s3];
      var _iterator5 = _createForOfIteratorHelper(l),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var i = _step5.value;
          i == null || i.apply(void 0, arguments);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }));
  };
  for (var _s3 in e) {
    _loop2(_s3);
  }
  return n;
}
function W(r) {
  var n;
  return Object.assign(j(r), {
    displayName: (n = r.displayName) != null ? n : r.name
  });
}
function m(r) {
  var n = Object.assign({}, r);
  for (var e in n) n[e] === void 0 && delete n[e];
  return n;
}
function h(r) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var e = Object.assign({}, r);
  var _iterator6 = _createForOfIteratorHelper(n),
    _step6;
  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var a = _step6.value;
      a in e && delete e[a];
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }
  return e;
}
export { M as RenderFeatures, O as RenderStrategy, m as compact, W as forwardRefWithAs, D as mergeProps, H as render, I as useMergeRefsFn };